import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalCadastroExcecaoComponent } from './modal-cadastro-excecao.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule, MatDatepickerModule, MatCheckboxModule, MatTableModule, MatPaginatorModule, MatNativeDateModule, MatDialogModule, MatTooltipModule, MatCardModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/main/content/shared/shared.module';
import { NgxLoadingModule } from 'ngx-loading';

const routes = [
  {
    path: 'modalmensagemExcecao',
    component: ModalCadastroExcecaoComponent
  }
];
@NgModule({
  declarations: [ModalCadastroExcecaoComponent],
  imports: [
     CommonModule,
     RouterModule.forChild(routes),
     SharedModule,
     MatButtonModule,
     MatFormFieldModule,
     MatIconModule,
     MatInputModule,
     MatSelectModule,
     MatDatepickerModule,
     MatCheckboxModule,
     MatTableModule,
     MatPaginatorModule,
     MatNativeDateModule,
     MatDialogModule,
     MatTooltipModule,
     HttpClientModule,
     NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
     MatCardModule,
     MatDialogModule,
     FormsModule,
  ],
    entryComponents: [ModalCadastroExcecaoComponent] // 👈 AQUI
})
export class ModalCadastroExcecaoModule { }